// @ts-nocheck
/* eslint-disable */
/* NOTE: Auto-generated. Run `yarn build-icons` instead of editing. */
import { ReactComponent as LineageExtended } from '../../../assets/icons/extended/entities/lineage.svg?react';
import { createIcons } from '../../Icon';
const LineageIcon = /* @__PURE__ */ createIcons('Lineage', {
    extended: LineageExtended
});
LineageIcon.supportedTypes = ['extended'];
LineageIcon.category = 'entities';
export default LineageIcon;
